// extracted by mini-css-extract-plugin
export default {"image":"z2-z","loaded":"A2-z"};